/**
 * O que fazer com a tela aberta depois que o Assistente gravou.
 *
 * Dois avisos chegam ao host, e eles NÃO têm a mesma régua:
 *
 * - `tela_afetada` (R6): a mutação nomeou a tela dona do dado e o host já
 *   conferiu que é a rota aberta (`telaAbertaFicouVelha`). Sem revalidador
 *   registrado, remontar o componente da rota é o fallback de sempre;
 * - `turno_da_conversa`: o turno gravou, mas não diz ONDE. A tela aberta pode
 *   ser qualquer uma — inclusive um cadastro meio preenchido. Remontá-la
 *   apagaria o que a pessoa digitou (revisão do PR #3582). Sem revalidador,
 *   a chave do router-view fica onde está e o host só avisa que a tela pode
 *   estar desatualizada.
 *
 * Em ambos, a tela que registrou como se revalida é chamada primeiro.
 */
import { revalidarTelaRegistrada } from './revalidadorDaTela'

export type OrigemDaRevalidacao = 'tela_afetada' | 'turno_da_conversa'

export interface DesfechoDaRevalidacao {
  /** A `:key` do router-view depois da decisão; mudar remonta a tela. */
  chaveDaView: number
  /** Nada revalidou: a pessoa precisa saber que a tela pode estar velha. */
  avisarTelaDesatualizada: boolean
}

export function decidirRevalidacaoDaTelaAberta (
  origem: OrigemDaRevalidacao,
  chaveDaView: number,
  revalidar: () => boolean = revalidarTelaRegistrada
): DesfechoDaRevalidacao {
  if (revalidar()) return { chaveDaView, avisarTelaDesatualizada: false }
  if (origem === 'tela_afetada') return { chaveDaView: chaveDaView + 1, avisarTelaDesatualizada: false }
  return { chaveDaView, avisarTelaDesatualizada: true }
}
